export default __webpack_public_path__ + "static/media/flag-pt-PT.8cd95607.svg";